<template>
  <div class="tab-wrap">
    <!-- 탭메뉴 -->
    <TabMenu />
    <div class="list-container">
      <!-- <vs-tabs vs-alignment="center" :value="$route.query.activeTab"> -->
      <vs-tab v-if="false" :label="$t('gnb.transactionHistory.menu.asset')">
        <!-- 자산탭//S -->
        <div class="well well-black my-asset text-center">
          <dl class="dl-horizontal">
            <dt>{{ $t("sideMenu.totalAsset") }}</dt>
            <dd>
              <strong>{{ totalAssetToKRW | formatNumber }}</strong>
              <small>KRW</small>
            </dd>
          </dl>
          <dl class="dl-horizontal">
            <dt>{{ $t("sideMenu.available") }}</dt>
            <dd>
              <strong>{{ totalAvailToKRW | formatNumber }}</strong>
              <small>KRW</small>
            </dd>
          </dl>
        </div>
        <div class="my-asset-list">
          <!-- 내 자산 리스트//S -->
          <ul>
            <li
              v-for="(coin, index) in coins"
              :key="index"
              :class="{ active: coin.active }"
            >
              <!-- Asset panel//S -->
              <div
                class="asset-panel clearfix"
                @click="coin.active = !coin.active"
              >
                <h3 class="pull-left">
                  <img :src="coin.img" /> {{ coin.name }}
                </h3>
                <div class="pull-right text-right" v-if="coin.code === 'KRW'">
                  <h4>
                    {{ coin.amount | formatNumber }}
                    <small>{{ $bnCode(coin.code) }}</small>
                  </h4>
                  <h5>
                    {{ $t("sideMenu.available") }}
                    {{ coin.available | formatNumber }}
                  </h5>
                </div>
                <div class="pull-right text-right" v-else>
                  <h4>
                    {{ coin.amount | formatNumber(8) }}
                    <small>{{ $bnCode(coin.code) }}</small>
                  </h4>
                  <small class="tokrw"
                    >≒ {{ coin.tokrw | formatNumber }} KRW</small
                  >
                  <h5>
                    {{ $t("sideMenu.available") }}
                    {{ coin.available | formatNumber(8) }}
                  </h5>
                </div>
              </div>
              <!-- Asset panel//E -->
              <div class="asset-hidden-area">
                <!-- KRW 일때만//S -->
                <!-- ul class="list-justified" v-if="coin.code === 'KRW'">
                    <li>
                      <router-link to="/withdraw" class="btn-block">
                        입금
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/withdraw" class="btn-block">
                        출금
                      </router-link>
                    </li>
                  </ul -->

                <!-- KRW 일때만//E -->
                <ul class="list-justified">
                  <li>
                    <router-link
                      :to="`/trade/KRW/${coin.code}`"
                      v-if="coin.availMarkets('KRW')"
                      class="btn-block"
                    >
                      KRW {{ $t("trade.info.market") }}
                    </router-link>
                  </li>
                  <!-- li>
                      <router-link :to="`/trade/BTC/${coin.code}`" v-if="coin.availMarkets('BTC')" class="btn-block">
                        BTC 마켓
                      </router-link>
                    </li>
                    <li>
                      <router-link :to="`/trade/ETH/${coin.code}`" v-if="coin.availMarkets('ETH')" class="btn-block">
                        ETH 마켓
                      </router-link>
                    </li -->
                </ul>
              </div>
            </li>
          </ul>
          <!-- 내 자산 리스트//E -->
        </div>
        <!-- 자산탭//E -->
      </vs-tab>

      <!-- 거래탭//S -->
      <div class="well well-black clearfix">
        <vs-row class="date-search-wrap">
          <vs-col vs-justify="center" vs-align="center" vs-w="6">
            <div class="date-select">
              <input
                type="date"
                class="input-custom"
                v-model="tradeStartDate"
              />
            </div>
          </vs-col>
          <vs-col vs-justify="center" vs-align="center" vs-w="6">
            <div class="date-select">
              <input type="date" class="input-custom" v-model="tradeEndDate" />
            </div>
          </vs-col>
        </vs-row>
        <vs-row class="coin-select-wrap">
          <vs-col vs-justify="center" vs-align="center" vs-w="12">
            <vs-select v-model="selectedCoin">
              <vs-select-item
                :key="coin.id"
                :value="coin.id"
                :text="coin.name"
                v-for="coin in coinList"
              />
            </vs-select>
          </vs-col>
          <span class="input-group-btn"
            ><vs-button
              color="#f01b5c"
              size="small"
              type="filled"
              @click="getTradingHistory"
              >{{ $t("trade.log.search") }}</vs-button
            ></span
          >
        </vs-row>
      </div>

      <table class="data-table text-center">
        <thead>
          <tr>
            <th class="en-small">
              {{ $t("trade.log.Time") }}<br />
              {{ $t("trade.info.market") }}/{{ $t("tradeLog.Coin") }}/{{
                $t("tradeLog.type")
              }}
            </th>
            <th class="en-small">
              {{ $t("trade.orderBook.orderQuantity") }}<br />{{
                $t("trade.log.Fee")
              }}
            </th>
            <th class="en-small">
              {{ $t("trade.log.ExecutionPrice") }}<br />{{
                $t("trade.log.TotalExecuted")
              }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(tradingList, index) in tradingHistory" :key="index">
            <td>
              {{ tradingList.date }}<br />
              {{ tradingList.baseCoinCode }}/{{ tradingList.coinCode }}/
              <span v-if="tradingList.oc_type == 'B'" class="txt-red">{{
                $t("tradeLog.buyLimit")
              }}</span>
              <span v-else class="txt-blue">{{
                $t("tradeLog.sellLimit")
              }}</span>
            </td>
            <td>
              {{ tradingList.amount | formatNumber(8) }}<br />
              {{ tradingList.fee | formatNumber(8) }}
            </td>
            <td>
              <span v-if="tradingList.baseCoinCode === 'KRW'">
                {{ tradingList.chePrice | formatNumber }}<br />
              </span>
              <span v-else>
                {{ tradingList.chePrice | formatNumber(8) }}<br />
              </span>
              {{ tradingList.cheAmount | formatNumber(8) }}
            </td>
          </tr>
        </tbody>
      </table>
      <Pagination
        v-if="tradingHistory.length != 0"
        :current-page="tradingHistoryPage.currentPage"
        :total-page="tradingHistoryPage.totalPage"
        @next-page="nextPage('getTradingHistory')"
        @prev-page="prevPage('getTradingHistory')"
      ></Pagination>
      <!-- 거래탭//E -->
      <!-- KRW 입출금 탭//S -->
      <vs-tab
        v-if="false"
        :label="$t('gnb.transactionHistory.menu.KRWTransactionHistory')"
      >
        <div class="well well-black clearfix">
          <vs-row class="date-select-wrap">
            <vs-col vs-justify="center" vs-align="center" vs-w="6">
              <div class="date-select">
                <input
                  type="date"
                  class="input-custom"
                  v-model="KRWStartDate"
                />
              </div>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-w="6">
              <div class="date-select">
                <input type="date" class="input-custom" v-model="KRWEndDate" />
              </div>
            </vs-col>
          </vs-row>
          <span
            class="input-group-btn"
            style="margin-top:20px;margin-left:-45px;"
            ><vs-button
              color="#f01b5c"
              size="small"
              type="filled"
              @click="getKRWHistory"
              >{{ $t("trade.log.search") }}</vs-button
            ></span
          >
        </div>
        <table class="data-table text-center">
          <thead>
            <tr>
              <th class="sn-small">{{ $t("trade.log.Time") }}</th>
              <th class="sn-small">{{ $t("tradeLog.type") }}</th>
              <th class="sn-small">{{ $t("tradeLog.price") }}</th>
              <th class="sn-small">{{ $t("tradeLog.Fee") }}</th>
              <th class="sn-small">{{ $t("tradeLog.status") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(krwDepositWithdrawList, index) in krwDepositWithdrawLists"
              :key="index"
            >
              <td>{{ krwDepositWithdrawList.date }}</td>
              <td>
                {{
                  krwDepositWithdrawList.transferType == "입금"
                    ? $t("tradeLog.deposit")
                    : $t("tradeLog.withdrawal")
                }}
              </td>
              <td>{{ krwDepositWithdrawList.amount | formatNumber }}</td>
              <td>{{ krwDepositWithdrawList.fee | formatNumber }}</td>
              <td>
                <span v-if="krwDepositWithdrawList.status === '처리중'">{{
                  $t("trade.log.pending")
                }}</span>
                <span v-else-if="krwDepositWithdrawList.status == '취소'">
                  {{ $t("confirm.cancel") }}
                </span>
                <span v-else-if="krwDepositWithdrawList.status == '승인'">
                  {{ $t("trade.log.approval") }}
                </span>
                <span v-else-if="krwDepositWithdrawList.status == '실패'">
                  {{ $t("tradeLog.fail") }}
                </span>
                <span v-else>
                  {{ krwDepositWithdrawList.status }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <Pagination
          :current-page="krwHistoryPage.currentPage"
          :total-page="krwHistoryPage.totalPage"
          @next-page="nextPage('getKRWHistory')"
          @prev-page="prevPage('getKRWHistory')"
        ></Pagination>
      </vs-tab>
      <!-- KRW 입출금 탭//E -->
      <vs-tab
        v-if="false"
        :label="$t('gnb.transactionHistory.menu.cryptocurrencyHistory')"
      >
        <!-- 암호화폐입출금 탭//S -->
        <div class="well well-black clearfix">
          <vs-row class="date-select-wrap">
            <vs-col vs-justify="center" vs-align="center" vs-w="6">
              <div class="date-select">
                <input
                  type="date"
                  class="input-custom"
                  v-model="coinStartDate"
                />
              </div>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-w="6">
              <div class="date-select">
                <input type="date" class="input-custom" v-model="coinEndDate" />
              </div>
            </vs-col>
          </vs-row>
          <span
            class="input-group-btn"
            style="margin-top:20px;margin-left:-45px;"
            ><vs-button
              color="#f01b5c"
              size="small"
              type="filled"
              @click="getCoinHistory"
              >{{ $t("trade.log.search") }}</vs-button
            ></span
          >
        </div>
        <table class="data-table text-center">
          <colgroup>
            <col width="120" />
            <col width="60" />
            <col width="*" />
          </colgroup>
          <thead>
            <tr>
              <th>
                {{ $t("trade.log.Time") }}<br />{{ $t("tradeLog.CoinType") }}
              </th>
              <th>
                {{ $t("tradeLog.Coin") }}<br />{{ $t("tradeLog.status") }}
              </th>
              <th>
                {{ $t("tradeLog.amount") }}<br />{{ $t("tradeLog.TXID") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(coinDepositWithdrawList,
              index) in coinDepositWithdrawLists"
              :key="index"
            >
              <td class="text-left">
                {{ coinDepositWithdrawList.date }}<br />
                {{ coinDepositWithdrawList.transferType }}
              </td>
              <td>
                {{ coinDepositWithdrawList.coinCode }}<br />
                {{ coinDepositWithdrawList.status }}
              </td>
              <td class="text-left">
                {{ coinDepositWithdrawList.amount | formatNumber(8) }}
                <div class="text-ellipsis">
                  {{ coinDepositWithdrawList.transactionId }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- 암호화폐입출금 탭//E -->
        <Pagination
          :current-page="coinHistoryPage.currentPage"
          :total-page="coinHistoryPage.totalPage"
          @next-page="nextPage('getCoinHistory')"
          @prev-page="prevPage('getCoinHistory')"
        ></Pagination>
      </vs-tab>
      <!-- </vs-tabs> -->
    </div>
  </div>
</template>
<script>
// import krwIcon from "../../assets/icon_coin_krw.png"
// import btcIcon from "../../assets/icon_coin_btc.png"
// import bchIcon from "../../assets/icon_coin_bch.png"
// import ethIcon from "../../assets/icon_coin_eth.png"
// import etcIcon from "../../assets/icon_coin_etc.png"
// import xrpIcon from "../../assets/icon_coin_xrp.png"
// import xmrIcon from "../../assets/icon_coin_xmr.png"
// import ltcIcon from "../../assets/icon_coin_ltc.png"
// import qtumIcon from "../../assets/icon_coin_qtum.png"
// import dentIcon from "../../assets/icon_coin_dent.png"

import Decimal from "decimal.js";

import { mapGetters, mapState } from "vuex";

import Pagination from "@/components/common/pagination";
import Store from "@/store/";
import TabMenu from "../investments/tabMenu.vue";

export default {
  created() {},
  data() {
    return {
      actives: 0,
      tradeStartDate: this.moment()
        .subtract(1, "M")
        .format("YYYY-MM-DD"),
      tradeEndDate: this.moment().format("YYYY-MM-DD"),
      KRWStartDate: this.moment()
        .subtract(1, "M")
        .format("YYYY-MM-DD"),
      KRWEndDate: this.moment().format("YYYY-MM-DD"),
      coinStartDate: this.moment()
        .subtract(1, "M")
        .format("YYYY-MM-DD"),
      coinEndDate: this.moment().format("YYYY-MM-DD"),
      tradingHistory: [],
      krwDepositWithdrawLists: [],
      coinDepositWithdrawLists: [],
      /** pagenation */
      tradingHistoryPage: {
        currentPage: 1,
        totalPage: 1,
        method: this.getTradingHistory,
      },
      krwHistoryPage: {
        currentPage: 1,
        totalPage: 1,
        method: this.getKRWHistory,
      },
      coinHistoryPage: {
        currentPage: 1,
        totalPage: 1,
        method: this.getCoinHistory,
      },
      selectedCoin: 2,
      options1: [
        { text: "IT", value: 0 },
        { text: "Blade Runner", value: 1 },
        { text: "Thor Ragnarok", value: 2 },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "totalAssetToKRW",
      "marketsByDealCoin",
      "totalAvailToKRW",
      "toKRW",
      "wallet",
      "coinWallet",
    ]),
    ...mapState(["Server"]),
    coins() {
      return _.map(this.wallet, (wallet) => {
        return {
          name: wallet.coin.name,
          img: `//static.flybit.com/static/img/mobile/coin_${wallet.coin.code}.png`,
          amount: wallet.total,
          tokrw: new Decimal(this.toKRW(this.$bnCode(wallet.coin.code)).price)
            .mul(wallet.total)
            .toNumber(),
          available: wallet.available,
          code: wallet.coin.code,
          active: wallet.coin.enable === "Y",
          availMarkets: (code) => {
            const availMarkets = _.get(
              this.marketsByDealCoin,
              wallet.coin.code,
              []
            ).map((market) => market.baseCoinCode);
            return availMarkets.includes(code);
          },
        };
      });
    },
    coinList() {
      const coinList = this._.map(this.$store.state.Market.coin).filter(
        (coins) => coins.code !== "KRW"
      );
      return _.sortBy(coinList, ["sort"]);
    },
  },
  mounted() {
    this.getTradingHistory();
    this.getKRWHistory();
    this.getCoinHistory();
  },
  methods: {
    getTradingHistory() {
      const params = {
        cidx: this.selectedCoin,
        completed: "Y",
        fromDate: this.moment(this.tradeStartDate).toISOString(),
        toDate: this.moment(this.tradeEndDate).toISOString(),
        page: this.tradingHistoryPage.currentPage,
        count: 10,
      };

      this.$api.User.tradeOrderHistory(params).then((response) => {
        this.tradingHistoryPage.totalPage =
          response.pagination.totalPages === 0
            ? 1
            : response.pagination.totalPages;
        this.tradingHistory = response.body;
      });
    },
    getKRWHistory() {
      const params = {
        fromDate: this.moment(this.KRWStartDate).toISOString(),
        toDate: this.moment(this.KRWEndDate).toISOString(),
        page: this.krwHistoryPage.currentPage,
        count: 10,
      };
      return this.$api.Transfer.getKRWTransferHistory(params).then(
        (response) => {
          this.krwHistoryPage.totalPage =
            response.pagination.totalPages === 0
              ? 1
              : response.pagination.totalPages;
          this.krwDepositWithdrawLists = response.body;
        }
      );
    },
    getCoinHistory() {
      const params = {
        fromDate: this.moment(this.coinStartDate).toISOString(),
        toDate: this.moment(this.coinEndDate).toISOString(),
        page: this.coinHistoryPage.currentPage,
        count: 10,
      };
      return this.$api.Transfer.getTransferHistory(params).then((response) => {
        //this.coinDepositWithdrawLists = response.body;
        this.coinHistoryPage.totalPage =
          response.pagination.totalPages === 0
            ? 1
            : response.pagination.totalPages;
        this.coinDepositWithdrawLists = _.map(response.body, (row) => {
          return {
            ...row,
            coinCode: _.get(Store.getters, ["coinIdMap", row.coinId, "code"]),
          };
        });
      });
    },
    nextPage(board) {
      const page = this.getPagination(board);
      if (page.currentPage < page.totalPage) {
        page.currentPage++;
        page.method();
      }
    },
    prevPage(board) {
      const page = this.getPagination(board);
      if (page.currentPage > 1) {
        page.currentPage--;
        page.method();
      }
    },

    getPagination(board) {
      switch (board) {
        case "getTradingHistory":
          return this.tradingHistoryPage;
          break;
        case "getKRWHistory":
          return this.krwHistoryPage;
          break;
        case "getCoinHistory":
          return this.coinHistoryPage;
          break;
      }
    },
  },
  components: {
    Pagination,
    TabMenu,
  },
};
</script>
<style lang="scss" scoped>
.scrollX {
  overflow-x: scroll;
  height: 48px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
  .investList-menu {
    width: 454px;
    padding: 7px 12px;
    list-style: none;
    li {
      min-width: 88px;
      padding: 0 6px;
      margin-right: 8px;
      border: 1px solid #dcdfe3;
      border-radius: 52px;
      text-align: center;
      background-color: #fff;
      line-height: 32px;
      font-size: 12px;
      font-weight: normal;
      color: #333;
      &.active {
        border-color: #eb3246;
        background-color: #eb3246;
        color: #fff;
      }
    }
    a:last-child li {
      margin-right: 0;
    }
  }
}
.list-container {
  padding: 16px 10px;
}
</style>
